// JollyPets.co Theme JavaScript

(function () {
  'use strict';

  /* ============================================================
     ANNOUNCEMENT BAR — Mobile rotating messages
     ============================================================ */
  function initAnnouncementBar() {
    const items = document.querySelectorAll('.announcement-bar__item');
    const prevBtn = document.querySelector('.announcement-bar__nav-btn--prev');
    const nextBtn = document.querySelector('.announcement-bar__nav-btn--next');
    if (!items.length) return;

    let current = 0;

    function show(index) {
      items.forEach(function (el) { el.classList.remove('is-active'); });
      items[index].classList.add('is-active');
    }

    function next() { current = (current + 1) % items.length; show(current); }
    function prev() { current = (current - 1 + items.length) % items.length; show(current); }

    show(0);
    var interval = setInterval(next, 4000);

    if (nextBtn) nextBtn.addEventListener('click', function () { clearInterval(interval); next(); interval = setInterval(next, 4000); });
    if (prevBtn) prevBtn.addEventListener('click', function () { clearInterval(interval); prev(); interval = setInterval(next, 4000); });
  }

  /* ============================================================
     MOBILE NAV
     ============================================================ */
  function initMobileNav() {
    const openBtn = document.querySelector('.mobile-menu-btn');
    const closeBtn = document.querySelector('.mobile-nav__close');
    const nav = document.querySelector('.mobile-nav');
    const overlay = document.querySelector('.mobile-nav-overlay');

    function open() {
      nav && nav.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      nav && nav.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtn && openBtn.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ============================================================
     SEARCH OVERLAY
     ============================================================ */
  function initSearch() {
    const openBtns = document.querySelectorAll('[data-search-open]');
    const overlay = document.querySelector('.search-overlay');
    const input = overlay && overlay.querySelector('.search-overlay__input');

    function open() {
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input && input.focus(); }, 100);
    }
    function close() {
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    overlay && overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  function initCartDrawer() {
    const openBtns = document.querySelectorAll('[data-cart-open]');
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-overlay');
    const closeBtn = document.querySelector('.cart-drawer__close');

    function open() {
      drawer && drawer.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer && drawer.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ============================================================
     QUANTITY CONTROLS
     ============================================================ */
  function initQtyControls() {
    document.querySelectorAll('.qty-control').forEach(function (ctrl) {
      const minus = ctrl.querySelector('.qty-btn--minus');
      const plus  = ctrl.querySelector('.qty-btn--plus');
      const input = ctrl.querySelector('.qty-input');
      if (!input) return;

      minus && minus.addEventListener('click', function () {
        const val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus && plus.addEventListener('click', function () {
        const val = parseInt(input.value, 10);
        const max = parseInt(input.getAttribute('max') || 99, 10);
        if (val < max) input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ============================================================
     PRODUCT GALLERY — thumbnail switching
     ============================================================ */
  function initProductGallery() {
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const mainImg = document.querySelector('.product-gallery__main img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        const src = thumb.getAttribute('data-src');
        if (src) mainImg.src = src;
      });
    });
  }

  /* ============================================================
     ADD TO CART — AJAX
     ============================================================ */
  function initAddToCart() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.add-to-cart-btn');
      if (!btn) return;

      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(form);

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            btn.textContent = 'Error';
            setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2000);
          } else {
            btn.textContent = '✓ Added!';
            btn.style.background = '#7a8f7e';
            updateCartCount();
            // Open cart drawer
            var drawer = document.querySelector('.cart-drawer');
            var cartOverlay = document.querySelector('.cart-overlay');
            if (drawer) drawer.classList.add('is-open');
            if (cartOverlay) cartOverlay.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            refreshCartDrawer();
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
              btn.style.background = '';
            }, 3000);
          }
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  /* ============================================================
     CART COUNT + REFRESH
     ============================================================ */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var counts = document.querySelectorAll('.cart-count');
        counts.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  function refreshCartDrawer() {
    var body = document.querySelector('.cart-drawer__body');
    var foot = document.querySelector('.cart-drawer__foot');
    if (!body) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">🛒</div><p class="cart-empty__msg">Your cart is empty</p><a href="/collections/all" class="view-all-btn" style="display:inline-flex;margin:0 auto;">Shop Now →</a></div>';
          if (foot) foot.style.display = 'none';
          return;
        }

        if (foot) foot.style.display = '';

        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-line-item">';
          html += '<div class="cart-line-item__img"><img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy"></div>';
          html += '<div class="cart-line-item__info">';
          html += '<div class="cart-line-item__title">' + item.product_title + '</div>';
          if (item.variant_title) html += '<div class="cart-line-item__variant">' + item.variant_title + '</div>';
          html += '<div class="cart-line-item__row">';
          html += '<span class="cart-line-item__price">' + formatMoney(item.final_line_price) + '</span>';
          html += '<div class="cart-line-item__qty"><button class="qty-btn qty-btn--minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button><input class="qty-input" value="' + item.quantity + '" readonly><button class="qty-btn qty-btn--plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button></div>';
          html += '</div></div></div>';
        });
        body.innerHTML = html;

        // Update subtotal
        var subtotalEl = document.querySelector('.cart-subtotal .subtotal-amount');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        // Bind qty buttons in drawer
        body.querySelectorAll('.qty-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = btn.getAttribute('data-key');
            var qty = parseInt(btn.getAttribute('data-qty'), 10);
            if (qty < 0) qty = 0;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: qty })
            })
              .then(function () { updateCartCount(); refreshCartDrawer(); });
          });
        });
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }

  /* ============================================================
     VARIANT SELECTOR
     ============================================================ */
  function initVariants() {
    document.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.variant-options');
        if (group) {
          group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        }
        btn.classList.add('is-selected');

        // Update hidden variant input
        var variantInput = document.querySelector('input[name="id"]');
        var selectedId = btn.getAttribute('data-variant-id');
        if (variantInput && selectedId) {
          variantInput.value = selectedId;
        }
      });
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncementBar();
    initMobileNav();
    initSearch();
    initCartDrawer();
    initQtyControls();
    initProductGallery();
    initAddToCart();
    initVariants();
    updateCartCount();

    // Animate elements on scroll
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      document.querySelectorAll('.product-card, .trust-item, .category-item').forEach(function (el) {
        observer.observe(el);
      });
    }
  });
})();
